export * from './ArrowShapeTriangleALeftIcon';
export * from './ArrowShapeTriangleALeftIcon16Light';
export * from './ArrowShapeTriangleALeftIcon16Regular';
export * from './ArrowShapeTriangleALeftIcon16Solid';
export * from './ArrowShapeTriangleALeftIcon20Light';
export * from './ArrowShapeTriangleALeftIcon20Regular';
export * from './ArrowShapeTriangleALeftIcon20Solid';
export * from './ArrowShapeTriangleALeftIcon24Regular';
export * from './ArrowShapeTriangleALeftIcon24Solid';
export * from './ArrowShapeTriangleALeftIcon32Regular';
export * from './ArrowShapeTriangleALeftIcon64Regular';
